import { render, staticRenderFns } from "./ProductDiscountPricePopupIframe.vue?vue&type=template&id=f4f0042a&"
import script from "./ProductDiscountPricePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDiscountPricePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports